import * as Yup from 'yup';

const schema = Yup.object().shape({
  name: Yup.string(),
  lastName: Yup.string(),
});

export default schema;
